import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../../../components/styled/Elements";
import { EmailVerifiedModalImg } from "../../../../components/styled/AllImages";
import { useNavigate } from "react-router-dom";

const EmailSentModal = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Box className="d-flex flex-column align-items-center py-3 px-2">
          <Box>
            <LazyImage src={EmailVerifiedModalImg} />
          </Box>
          <Box>
            <HeadingStyled size="24px" weight="bold" color="var(--text)">
              {t("check_your_email")}
            </HeadingStyled>
          </Box>
          <Box>
            <TextStyled
              size="16px"
              weight="500"
              color="var(--text)"
              className="text-center px-3"
            >
              {t("we_emailed_you_instructions_to_reset_pass")}
            </TextStyled>
          </Box>
          <ButtonStyled
            onClick={() => {
              props.onHide();
              // navigate("/reset-password");
            }}
            className="w-100"
            clName="w-100"
            label={t("ok")}
          />
        </Box>
      </Modal.Body>
    </Modal>
  );
};

export default EmailSentModal;
